<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-hashtag</v-icon>
      <span class="ml-2 title">Agregar Hashtag</span>
    </v-card-title>
    <v-card-text>
      <v-text-field
        v-model="hashtag"
        label="#HashTag"
        :error-messages="errHashtag"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-btn color="primary" @click="saveHashtag">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// const hashtag = value => {
//   if (!value) {
//     return true
//   }
//   return /(?:\s|^)#[A-Za-z0-9-._]+(?:\s|$)/.test(value)
// }
export default {
  data () {
    return {
      hashtag: ''
    }
  },
  computed: {
    errHashtag () {
      const errs = []
      if (!this.$v.hashtag.$dirty) return errs
      !this.$v.hashtag.required && errs.push('El Hastag es requerido')
      // !this.$v.hashtag.hashtag && errs.push('El formato no es valido')
      return errs
    }
  },
  methods: {
    saveHashtag () {
      this.$v.hashtag.$touch()
      if (!this.$v.hashtag.$invalid) {
        this.$emit('save', this.hashtag)
        this.hashtag = ''
        this.$v.hashtag.$reset()
      }
    }
  },
  validations: {
    hashtag: {
      required
    }
  }
}
</script>
